import axios from "../api/axios";
import {FORGOT_PASSWORD_URL} from "../utils/constants";

export async function forgotPasswordService(data: any): Promise<any> {
    const response = await axios.post(FORGOT_PASSWORD_URL, data);
    return response.data;
}
